// Entrypoint del visualizador.
//
// Monta el shell (cabecera + zona de pasos + pie), inicializa el router y
// delega el render de cada paso al router. El estado vive en `shared/state.js`.
//
// Aquí no se hace lógica de cálculo, solo composición.

import { state, subscribe } from '/src/shared/state.js';
import { t } from '/src/shared/i18n.js';
import { renderProgressBar } from '/src/ui/components/progress-bar.js';
import { initRouter } from '/src/ui/router.js';

const TOTAL_STEPS = 6;

function buildShell() {
  const app = document.getElementById('app');
  if (!app) {
    throw new Error('No existe el contenedor #app en el HTML');
  }

  app.innerHTML = `
    <div class="shell">
      <header class="shell__header">
        <div class="shell__brand">${t('brand.name')} · ${t('app.title')}</div>
        <div id="progress-host"></div>
      </header>
      <main class="shell__main" id="step-host" aria-live="polite"></main>
      <footer class="shell__footer">
        ${t('brand.tagline')}
      </footer>
    </div>
  `;

  return {
    progressHost: document.getElementById('progress-host'),
    stepHost: document.getElementById('step-host'),
  };
}

function refreshProgress(progressHost) {
  renderProgressBar(progressHost, {
    current: state.step,
    total: TOTAL_STEPS,
  });
}

function boot() {
  const { progressHost, stepHost } = buildShell();

  refreshProgress(progressHost);
  subscribe(() => refreshProgress(progressHost));

  initRouter(stepHost, { totalSteps: TOTAL_STEPS });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot, { once: true });
} else {
  boot();
}
